import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { defaultLanguage, namespaces, supportedLanguages } from './languages';

export { defaultLanguage, namespaces, supportedLanguages, type LanguageCode } from './languages';

const syncDocumentLang = (lng: string | undefined) => {
  document.documentElement.lang = lng ?? defaultLanguage;
};

i18n.on('languageChanged', () => syncDocumentLang(i18n.resolvedLanguage));

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: defaultLanguage,
    supportedLngs: supportedLanguages.map((l) => l.code),
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    ns: namespaces,
    defaultNS: 'common',
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    // Only the user's saved choice is honoured; the browser locale is ignored so the app opens in English.
    detection: { order: ['localStorage'], caches: ['localStorage'] },
    interpolation: { escapeValue: false }, // React already escapes output
    returnNull: false,
  });

export default i18n;
